import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Bakim() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-10 w-auto"
                />
              </Link>
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  ANASAYFA
                </Link>
                <Link to="/hizmetler" className="text-gray-900 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HİZMETLERİMİZ
                </Link>
                <Link to="/markalar" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  MARKALAR
                </Link>
                <Link to="/hakkimizda" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  HAKKIMIZDA
                </Link>
                <Link to="/iletisim" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors">
                  İLETİŞİM
                </Link>
                <a 
                  href="https://3dprinterankara.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors"
                >
                  SATIŞ
                </a>
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                >
                  RANDEVU AL
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-red-600 transition-colors">Anasayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/hizmetler" className="hover:text-red-600 transition-colors">Hizmetler</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">Bakım ve Servis</span>
          </div>
        </div>
      </div>

      {/* Hero Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                3D Yazıcı <span className="text-red-600">Bakım ve Servis</span>
              </h1>
              <p className="text-xl text-gray-600 mb-8">
                Düzenli bakım ile 3D yazıcılarınızın ömrünü uzatıyoruz. Preventif bakım programları ile cihazlarınızın performansını maksimum seviyede tutuyoruz.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  Bakım Randevusu Al
                </Link>
                <a 
                  href="https://wa.me/903123945635"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer text-center"
                >
                  WhatsApp ile İletişim
                </a>
              </div>
            </div>
            <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
              <img 
                src="https://public.readdy.ai/ai/img_res/8392c7d6f7f87ff85db0cb0311203b99.jpg"
                alt="3D Yazıcı Bakım Hizmeti"
                className="w-full rounded-xl shadow-lg object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Maintenance Services */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bakım Hizmetlerimiz
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kapsamlı bakım programlarımızla cihazlarınızın uzun ömürlü olmasını sağlıyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-brush-line",
                title: "Genel Temizlik",
                description: "Tüm parçaların detaylı temizliği, toz ve artık temizleme"
              },
              {
                icon: "ri-drop-line",
                title: "Yağlama İşlemleri",
                description: "Hareketli parçaların uygun yağlarla yağlanması"
              },
              {
                icon: "ri-ruler-line",
                title: "Kalibrasyon",
                description: "Yatak seviyeleme ve eksen kalibrasyonu"
              },
              {
                icon: "ri-temp-hot-line",
                title: "Isıtma Sistemi Kontrolü",
                description: "Hotend ve yatak ısıtıcı performans kontrolü"
              },
              {
                icon: "ri-settings-3-line",
                title: "Mekanik Kontrol",
                description: "Kayış gerginliği, vida sıkılığı ve hareket kontrolü"
              },
              {
                icon: "ri-code-s-slash-line",
                title: "Yazılım Güncellemesi",
                description: "Firmware güncelleme ve ayar optimizasyonu"
              }
            ].map((service, index) => (
              <div 
                key={index}
                className={`bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${300 + index * 100}ms` }}
              >
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Maintenance Plans */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bakım Planları
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              İhtiyacınıza uygun bakım planı seçin, cihazınızın performansını koruyun
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                name: "Temel Bakım",
                period: "6 Ayda Bir",
                price: "₺299",
                features: [
                  "Genel temizlik",
                  "Temel kalibrasyon",
                  "Görsel kontrol",
                  "Performans testi",
                  "Rapor sunumu"
                ],
                popular: false
              },
              {
                name: "Kapsamlı Bakım",
                period: "3 Ayda Bir",
                price: "₺499",
                features: [
                  "Detaylı temizlik",
                  "Tam kalibrasyon",
                  "Yağlama işlemleri",
                  "Yazılım güncellemesi",
                  "Yedek parça kontrolü",
                  "Önleyici müdahale",
                  "Detaylı rapor"
                ],
                popular: true
              },
              {
                name: "Premium Bakım",
                period: "Aylık",
                price: "₺799",
                features: [
                  "Tüm kapsamlı hizmetler",
                  "Öncelikli destek",
                  "Acil müdahale",
                  "Yedek parça indirimi",
                  "Performans optimizasyonu",
                  "Teknik destek",
                  "Ücretsiz küçük tamirler"
                ],
                popular: false
              }
            ].map((plan, index) => (
              <div 
                key={index}
                className={`relative bg-white rounded-xl shadow-lg border-2 p-8 transition-all duration-300 hover:shadow-xl ${
                  plan.popular ? 'border-red-600 transform scale-105' : 'border-gray-200'
                } ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${400 + index * 100}ms` }}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-red-600 text-white px-4 py-2 rounded-full text-sm font-medium">
                      En Popüler
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                  <p className="text-gray-600 mb-4">{plan.period}</p>
                  <div className="text-4xl font-bold text-red-600 mb-2">{plan.price}</div>
                  <p className="text-gray-500">+ KDV</p>
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-red-600 mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <Link 
                  to="/iletisim"
                  className={`w-full py-3 rounded-lg font-medium transition-colors cursor-pointer text-center block ${
                    plan.popular 
                      ? 'bg-red-600 hover:bg-red-700 text-white' 
                      : 'border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white'
                  }`}
                >
                  Plan Seç
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Düzenli Bakımın Faydaları
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Neden düzenli bakım yaptırmalısınız?
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: "ri-time-line",
                title: "Uzun Ömür",
                description: "Cihazınızın kullanım ömrünü %50'ye kadar uzatır"
              },
              {
                icon: "ri-speed-up-line",
                title: "Yüksek Performans",
                description: "Sürekli optimum performans ve baskı kalitesi"
              },
              {
                icon: "ri-money-dollar-circle-line",
                title: "Maliyet Tasarrufu",
                description: "Büyük arızaları önleyerek tamir maliyetlerini azaltır"
              },
              {
                icon: "ri-shield-check-line",
                title: "Güvenilirlik",
                description: "Beklenmedik arızaları minimize eder"
              }
            ].map((benefit, index) => (
              <div 
                key={index}
                className={`text-center p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${500 + index * 100}ms` }}
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Maintenance Checklist */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Bakım Kontrol Listesi
            </h2>
            <p className="text-xl text-gray-600">
              Profesyonel bakım sürecimizde kontrol ettiğimiz tüm noktalar
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Mekanik Kontroller</h3>
              {[
                "Kayış gerginliği kontrolü",
                "Rulman ve lineer ray kontrolü",
                "Vida ve bağlantı sıkılığı",
                "Ekstruder mekanizma kontrolü",
                "Yatak seviyeleme kontrolü",
                "Hareket sistemleri testi"
              ].map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Elektronik Kontroller</h3>
              {[
                "Anakart ve bağlantı kontrolü",
                "Motor sürücü performansı",
                "Sensör kalibrasyonu",
                "Isıtma sistemi kontrolü",
                "Fan ve soğutma sistemi",
                "Yazılım ve firmware kontrolü"
              ].map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-line text-red-600 text-xl"></i>
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-red-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            3D Yazıcınızın Bakımı Zamanı mı?
          </h2>
          <p className="text-xl text-red-100 mb-8 max-w-2xl mx-auto">
            Düzenli bakım ile cihazınızın ömrünü uzatın. Hemen bakım randevusu alın.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:03123945635"
              className="bg-white text-red-600 hover:bg-red-50 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Hemen Ara
            </a>
            <a 
              href="https://wa.me/903123945635"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-red-600 px-8 py-4 rounded-lg text-lg font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 flex items-center space-x-3">
                <img 
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/103f0aa5168bbf3493dbdd0ab176c5e6.png" 
                  alt="3D Print Pro Logo" 
                  className="h-8 w-auto"
                />
              </h3>
              <p className="text-gray-400">
                Ankara'da 3D yazıcı tamir, bakım ve kurulum hizmetlerinde uzman ekip.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hizmetler/tamir" className="hover:text-white transition-colors">3D Yazıcı Tamiri</Link></li>
                <li><Link to="/hizmetler/bakim" className="hover:text-white transition-colors">Bakım Servisi</Link></li>
                <li><Link to="/hizmetler/kurulum" className="hover:text-white transition-colors">Kurulum</Link></li>
                <li><Link to="/hizmetler" className="hover:text-white transition-colors">Tüm Hizmetler</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Şirket</h4>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
                <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
                <li><a href="#" className="hover:text-white transition-colors">Referanslar</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">İletişim</h4>
              <div className="space-y-2 text-gray-400">
                <p>1459. Cad, İvedik OSB Özanadolu Sanayi Sitesi No:3, 06480 Yenimahalle/Ankara</p>
                <p>0541 456 56 35</p>
                <p>info@3dprinterservis.com</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 3D Print Pro. Tüm hakları saklıdır. | 
              <a href="https://cdco.com.tr" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Bu web tasarımı CDCO tarafından tasarlanmıştır
              </a>
            </p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <a
        href="https://wa.me/903123945635"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-all hover:scale-110 z-50 cursor-pointer"
        aria-label="WhatsApp ile iletişime geç"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>
    </div>
  );
}
